'use strict';

var schema_1 = require("../schema");

module.exports = new schema_1.Schema({
  include: [require('./json')]
});